import { HelpersServiceModule } from '@b2c/common/services/helpers/helpers.service';
import angular from 'angular';

export const PageHeadingDirectiveModule = angular.module('acme.common.directive.page.heading', [HelpersServiceModule])
.directive('pageHeading', [function() {

    return {
      restrict: 'A',
      replace: true,
      transclude: true,
      templateUrl: 'common/directives/page/heading/heading.tpl.html',
      scope: {
        title: '=',
        hideButton: '=',
        staticInfo: '=',
        buttonAction: '&',
        subheading: '@',
        buttonType: '@',
        buttonHref: '@',
        buttonSref: '@',
        buttonIcon: '@',
        buttonName: '@',
        buttonSubText: '@',
        buttonTarget: '@',
        hasInfo: '@'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', 'HelpersService', function($scope, HelpersService) {

        $scope.pageHeading = {

          target: '',

          showActions: true,

          init: function() {
            console.log('PageHeading::init');
            this.target = ($scope.buttonTarget) ? "target=" + $scope.buttonTarget : '';

            $scope.$on('pageHeading::hideActions', this.hideActions);
          },

          hideActions: function() {
            $scope.pageHeading.showActions = false;
          },

          action: function() {
            $scope.buttonAction();
          }, 

          getButtonLink: function() {
            return $scope.buttonHref + HelpersService.addDonationParams();
          }

        };

        $scope.pageHeading.init();

      }]

    };

}]).name;
